import Util from "../../lib/util.js";
import { client, gql } from "../../GraphQL.svelte";
import ProjectField from "./ProjectField.js";

let Accounting = {};

// before multiplier
Accounting.contributionFinancialValue = function(inputValue, field, contributor) {
  function hoursPerYear() {
      return parseInt(field.parameters.arguments[0].value);
  }

  const isTime = function () {
      return inputValue && ProjectField.isTimeField(field);
  }

  const isHourly = function () {
      return field && ProjectField.isHourlyRateField(field);
  }

  const isMonetary = function () {
      return !isTime();
  }

  let parsed = parseFloat(inputValue.value);

  if (isMonetary()) {
      return parsed / 100;
  }

  // year salary
  else if (!isHourly()) {
      return (parsed * (((contributor.marketAnnualSalary || 0) / 100) / hoursPerYear()));
  }

  // hourly rate
  else {
      return (parseFloat(inputValue.value) * ((contributor.hourlySalary || 0) / 100));
  }
};

// after multiplier
Accounting.contributionFinancialValueMultiplied = function(inputValue, fieldDef, contributor) {
  return fieldDef.multiplier * Accounting.contributionFinancialValue(inputValue, fieldDef, contributor);
};

export default Accounting;